import { useEffect, useMemo } from "react";
import { useSelector } from "react-redux";
import { UserExperienceInstance } from "../utils";

export const useUserExperience = (experienceId: number, refetch = false) => {
  const { userExperiences } = useSelector((state: any) => state.userExperience);
  const { token } = useSelector((state: any) => state.auth);

  const attendExperience = async () => {
    return UserExperienceInstance.attendExperience(experienceId);
  };

  const refresh = () => {
    UserExperienceInstance.getUserExperiences();
  };

  const isAttending = useMemo(() => {
    return userExperiences?.some((experience: any) => experience.experienceId === experienceId);
  }, [userExperiences, experienceId]);

  useEffect(() => {
    if (!refetch && userExperiences?.length) return;

    refresh();
  }, [token]);

  return {
    refresh,
    isAttending,
    attendExperience,
  };
};
